import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import HostBankAccount from './HostBankAccount';

export default async function action({ store }) {
  if (!store.getState().runtime.isAuthenticated) return { redirect: '/login?refer=/user/bank-account' };
  return { title: 'Cuenta bancaria', component: <UserLayout><HostBankAccount /></UserLayout> };
}
